import React from "react";
import PropTypes from "prop-types";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { searchCommissions as search } from "MODULES/Commissions/actions";
import {
  Check,
  CheckGroup,
  form,
  Form as AppForm,
  FormInput,
  Select
} from "MODULES/shared/components/Forms";
import { FREIGHT_COMPLETE_RESTRICTION } from "APP_ROOT/constants";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import { Col } from "react-bootstrap";
import { properCase } from "LIB/formatters/text";
import CommissionsTable from "./CommissionsTable";
import { PENDING, REVERSED, SEND_NOTIFICATION } from "../../constants";

const formName = "payAllCommissions";
const selector = formValueSelector(formName);

const hasUnapprovedActiveRepair = item =>
  item.source !== "sales_order_line_item" ||
  (item.source === "sales_order_line_item" &&
    (!item.active_repair_item ||
      !item.inventory.consignment_type ||
      item.exchange_sale ||
      item.active_repair_item.final_evaluation_approved));

export class Form extends React.Component {
  state = {
    commissions: [],
    commissionLoading: false
  };

  changeEmployee = ev => {
    this.setState({ commissionsLoading: true });

    const freightCompleteRestriction =
      useSettings()[FREIGHT_COMPLETE_RESTRICTION] || false;

    this.props
      .searchCommissions({
        ...this.props.initialValues.filters,
        status: [PENDING, REVERSED].join(","),
        page: 1,
        limit: 10000,
        employee_id: ev.target.value,
        freight_complete: freightCompleteRestriction,
        customer_paid: true,
        shipped: true
      })
      .then(resp => {
        const newComms = {};
        resp.forEach(item => {
          newComms[item.id] = hasUnapprovedActiveRepair(item);
        });
        this.props.change("commissions", newComms);
        this.setState({ commissions: resp, commissionsLoading: false });
      });
  };

  render() {
    const options = this.props.employees.map(employee => ({
      value: employee.id,
      text: employee.full_name
    }));

    return (
      <AppForm
        {...this.props}
        disabled={
          !this.props.selectedEmployee || this.state.commissionsLoading === true
        }
      >
        <AppForm.Body>
          <Col md={4}>
            <div className="form-group">
              <Field
                name="employee"
                component={Select}
                options={options}
                label="Employee"
                onChange={this.changeEmployee}
                required
              />
            </div>
          </Col>
          <Col md={4}>
            <div className="form-group">
              <Field
                name="filters.filter"
                component={FormInput}
                label="Filter"
                disabled
              />
            </div>
          </Col>
          <Col md={4}>
            <CheckGroup title={SEND_NOTIFICATION}>
              <Field
                name={SEND_NOTIFICATION}
                component={Check}
                label={properCase(SEND_NOTIFICATION)}
              />
            </CheckGroup>
          </Col>
          <CommissionsTable
            selectedCommissions={this.props.selectedCommissions}
            commissions={this.state.commissions}
            loading={this.state.commissionsLoading}
          />
        </AppForm.Body>
      </AppForm>
    );
  }
}

Form.propTypes = {
  employees: PropTypes.instanceOf(Array),
  initialValues: PropTypes.instanceOf(Object),
  searchCommissions: PropTypes.func.isRequired,
  selectedCommissions: PropTypes.instanceOf(Object),
  selectedEmployee: PropTypes.number,
  change: PropTypes.func
};

export default connect(
  state => ({
    selectedCommissions: selector(state, "commissions"),
    selectedEmployee: selector(state, "employee")
  }),
  dispatch => ({
    searchCommissions: params => dispatch(search(params))
  })
)(
  form({
    form: formName
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/PayAll/Form.jsx